export class DevChatFrontendToolBase {
  static get toolId() {
    throw new Error('Subclass must set static toolId');
  }

  static get description() {
    return '';
  }

  static get paramsSchema() {
    return { type: 'object', properties: {} };
  }

  static toSerializableDefinition() {
    const C = this;
    return {
      name: C.toolId,
      description: C.description,
      params: C.paramsSchema,
    };
  }

  async execute(_params, _context) {
    throw new Error('execute() not implemented');
  }

  /**
   * Optional hook called while the model is still streaming function arguments.
   * This is invoked from the renderer on each `function-call-params-chunk` event.
   *
   * Tools can use the provided helpers to update the tool bubble (e.g. show code
   * being proposed before the approve/deny UI appears).
   *
   * @param {{ paramsChunk?: string, paramsTextSoFar?: string, done?: boolean, functionName?: string, runId?: string, callIndex?: number }} _stream
   * @param {{ updateToolUi?: (toolUi: any) => void, clearToolUi?: () => void }} _uiApi
   * @returns {void|Promise<void>}
   */
  async onParamsChunk(_stream, _uiApi) {
    // Default: no UI preview during argument streaming.
  }

  async requestApproval(context, options = {}) {
    if (!context || typeof context.requestInteraction !== 'function') {
      throw new Error('Tool execution context is missing requestInteraction()');
    }

    const title =
      typeof options.title === 'string' && options.title.trim().length > 0
        ? options.title.trim()
        : 'Approval required';

    const interaction = await context.requestInteraction({
      type: 'approval',
      title,
      codeSnippet: typeof options.codeSnippet === 'string' ? options.codeSnippet : '',
      paramsText: typeof options.paramsText === 'string' ? options.paramsText : '',
      actions: [
        {
          id: 'approve',
          label: typeof options.approveLabel === 'string' ? options.approveLabel : 'Approve',
          variant: 'accent',
        },
        {
          id: 'deny',
          label: typeof options.denyLabel === 'string' ? options.denyLabel : 'Deny',
          variant: 'outline',
        },
      ],
    });

    return interaction?.actionId === 'approve';
  }

  static formatBubbleSummary(result) {
    if (result == null) return 'Done';
    if (typeof result === 'string') return result;
    try {
      return JSON.stringify(result);
    } catch {
      return String(result);
    }
  }
}
